<script>
import { APPS } from '@/store/types';
import { mapActions, mapGetters } from 'vuex';
import Carousel from '@/components/ui/Carousel.vue';

export default {
  name: 'AppSelector',
  components: { Carousel },
  props: {
    selectedApp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      carouselPosition: null,
    };
  },
  computed: {
    ...mapGetters({ apps: APPS }),
    sortedAppsList() {
      return this.apps
        .slice()
        .sort((a, b) => b.activeInstallCount - a.activeInstallCount);
    },
  },
  watch: {
    selectedApp: {
      immediate: true,
      handler(value) {
        if (!value) return;
        const index = this.sortedAppsList?.findIndex(
          app => app.packageName === value,
        );
        this.carouselPosition = index;
      },
    },
  },
  created() {
    if (!this.apps?.length) {
      this.fetchAppsList();
    }
  },
  methods: {
    ...mapActions({ fetchAppsList: APPS }),
    selectApp(app) {
      this.$emit('update:selected-app', app.packageName);
    },
  },
};
</script>

<template>
  <div class="app-selector">
    <Carousel
      v-if="carouselPosition !== null"
      :beginning-index="carouselPosition"
      :item-width="130"
    >
      <div
        v-for="app in sortedAppsList"
        :key="app.id"
        class="app-selector__item"
        :class="{
          'app-selector__item--selected': selectedApp === app.packageName,
        }"
        @click="selectApp(app)"
      >
        <img :src="app.icon" width="60" class="app-selector__app-icon" />
        <div class="app-selector__app-name text-small">{{ app.name }}</div>
      </div>
    </Carousel>
  </div>
</template>
<style lang="scss">
.app-selector {
  width: auto;
  max-width: 500px;

  &__item {
    width: 130px;
    text-align: center;
    flex-shrink: 0;
    flex-grow: 1;
    filter: grayscale(90%);
    cursor: pointer;
    transition: filter 0.2s;

    // &:hover,
    // &--selected {
    //   filter: grayscale(0%);
    // }
  }

  &__item--selected {
    filter: grayscale(0%);
  }

  &__app-icon {
    border-radius: 22px;
    width: 70px;
    height: 70px;
  }

  &__app-name {
    margin-top: $global-margin * 0.5;
    text-align: center;
    max-width: 80%;
    display: inline-block;
  }
}
</style>
